import React from "react";
import tw, { styled, css } from "twin.macro";
import { graphql, useStaticQuery } from "gatsby";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

import Stars from "../components/Stars";
import ThumbnailVideo from "../components/ThumbnailVideo";
import Button from "../components/Button";

const Section = tw.section`py-20 flex flex-col items-center relative w-full overflow-hidden px-4 sm:px-12`;
const Review = styled.div(({ animate }) => [
  tw`text-center font-mazuis italic leading-loose font-normal [em]:(text-primary italic) text-4xl sm:text-5xl md:text-6xl xl:text-7xl  ease-in-out duration-1000 mb-8`,
]);

const Videos = tw.div`flex flex-col lg:(flex-row gap-20) w-full md:px-12 mb-28`;

const Slick = styled(Slider)(() => [
  tw`mb-28 items-center w-full`,
  css`
    .slick-dots {
      ${tw`flex justify-center w-full`}
      li {
        ${tw`bg-primary p-1 duration-500 ease-in-out rounded-full bg-opacity-20 mx-1.5 [&.slick-active]:(bg-opacity-100 scale-[130%])`}
        button {
        }
      }
    }
  `,
]);

const FrontReviews = ({ ...rest }) => {
  const { button, videos, reviews } = useStaticQuery(graphql`
    {
      wp {
        acfOptionsFrontReviews {
          frontReviews {
            button: frButton {
              ...Button
            }
            reviews: frReviews {
              review
            }
            videos: frVideos {
              embed: videoEmbed
              thumbnail: videoThumbnail {
                ...GatsbyImage_Blur
              }
            }
          }
        }
      }
    }
  `).wp.acfOptionsFrontReviews.frontReviews;

  const settings = {
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    speed: 700,
    infinite: true,
    appendDots: (dots) => <ul>{dots}</ul>,
    customPaging: (i) => <div></div>,
  };

  return (
    <Section {...rest}>
      <Stars tw="mb-8" />
      <Slick {...settings}>
        {reviews.map(({ review }, i) => {
          return (
            <Review
              key={i}
              dangerouslySetInnerHTML={{ __html: review }}
              // animate={animate}
            />
          );
        })}
      </Slick>
      <Videos>
        {videos.map((video, i) => (
          <ThumbnailVideo key={i} top={i === 0} bottom={i === 1} {...video} />
        ))}
      </Videos>
      <Button {...button} />
    </Section>
  );
};

export default FrontReviews;
